<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    clip-path="url(#a)"
  ><path d="M19.5 8.25h2.25a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-7.5M9.75 14.25h-6v-6h12M15.75 12v2.25M.75 8.25v6M.75 23.25 23.25.75M5.25.75a3 3 0 0 1-3 3 1.5 1.5 0 0 0-1.5 1.5" /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
